/** Configuration badge status. Separate from runtime BadgeStatus. */
export enum ConfigBadgeStatus {
  /** Camera requires credentials (ONVIF/RTSP auth). */
  AUTHENTICATE = 'authenticate',

  /** No model identified, or a listed brand's generic "Other" model. Badge copy: "Select model". */
  SELECT_DRIVER = 'select_driver',

  /** Driver set but PTZ control connection failed or unconfigured. */
  CONNECT_CONTROLS = 'connect_controls',

  /** Camera connected but never calibrated. Calibration is available. */
  CALIBRATE_CAMERA = 'calibrate_camera'
}

/** Settings tab to deep-link to when badge is clicked. */
export type SettingsTab = 'driver' | 'control' | 'video' | 'monitoring' | 'authentication';
